export const GUEST_ROUTES = {
  RECOVER: (recoveryKey = ":recoveryKey") => `/recover/${recoveryKey}`,
  PUBLIC_SCENARIOS: () => "/public-scenarios",
  PUBLIC_GAMES: () => "/public-games",
  DIALOG: (id = ":id") => `/dialogs/${id}`,
  ROLEPLAY: (alias = ":alias") => `/roleplay/${alias}`,
  STRIPE_CB: (status = ":status") => `/stripe-cb/${status}`,
  ALL_ROLEPLAYS: () => "/all-roleplays",
  SCENARIOS_GENERATOR: () => "/scenarios-generator",
  NOT_FOUND: () => "*",
  PRIVACY_POLICY: () => "/privacy-policy",
  TERMS_OF_SERVICE: () => "/terms-of-service",
  TAG: (tagName = ":tagName") => `/tag/${tagName}`,
  CHARACTER: (characterId = ":characterId") => `/characters/${characterId}`,
  CHAT: (chatName = ":chatName") => `/chats/${chatName}`,
  SCENARIOS_TYPE: (type = ":type") => `/scenarios/${type}`,
  ROOT: () => "/",
  CPA: () => "/cpa",
};

export const USER_ROUTES = {
  ...GUEST_ROUTES,
  PROFILE: () => "/profile",
  HISTORY: () => "/history",
  UPGRADE_SUBSCRIPTION: () => "/upgrade-subscription",
};

export const ADMIN_ROUTES = {
  ...USER_ROUTES,
  TAGS: () => "/tags",
  SETTINGS: () => "/settings",
  CONFIGS: () => "/configs",
  SCENARIOS: () => "/scenarios",
  STATS: () => "/stats",
  RESPONSE_TIME: () => "/response-time",
  TOOLS: () => "/tools",
  MARKETING: () => "/marketing",
  AB_TESTS: () => "/ab-tests",
  ADMIN_FEATURE_FLAGS: () => "/admin/feature-flags",
  ADMIN_BANNERS: () => "/admin/banners",
  ADMIN_CHATS: () => "/admin/chats",
  ADMIN_CHARACTERS: () => "/admin/characters",
  ADMIN_CHARACTER_DETAIL: (id = ":id") => `/admin/characters/${id}`,
  ADMIN_TOKENS: () => "/admin/tokens",
  ADMIN_MEDIA_PACKS: () => "/media-packs",
  USERS: () => "/admin/users",
  G2A: () => "/admin/g2a",
  SCENARIO_DIALOG: (alias = ":alias", scenarioId = ":scenarioId") =>
    `/scenario-dialog/${alias}/${scenarioId}`,
  SCENARIO_DEBUG: (alias = ":alias", scenarioId = ":scenarioId") =>
    `/scenario-debug/${alias}/${scenarioId}`,
};

